import React from 'react';
import View from './View/index.web';
import { useViewModel } from './viewModel';
import { GuestDropdownProps } from './types';

const Main = (props: GuestDropdownProps) => {
    const viewModelProps = useViewModel(props);
    return <View {...viewModelProps} />;
};

export default Main;
